module.exports = __webpack_public_path__ + "static/media/steering-stering-suspension-evaluation.a11e8d0c.svg";